export default __webpack_public_path__ + "98f2fda597f85b6c0a405a42f459940d.png";